import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LayoutService {
  // theme menu sidebar show and hide
  layoutState = new Subject();

  // theme component page  menu sidebar show and hide
  componentState = new Subject();

  // theme sidebar direction change in rtl mode
  directionChange: Subject<string> = new Subject();

  // kanban app in edit sidebar open
  kanbanSlider = new Subject();

  drawerOpen = false;
  componentDrawerOpen = false;
  editWindowOpen = true;

  toggleSideDrawer() {
    this.layoutState.next(!this.drawerOpen);
  }
  toggleMenuSide() {
    this.componentState.next(!this.componentDrawerOpen);
  }

  toggleEditTask() {
    this.kanbanSlider.next(!this.editWindowOpen);
  }
}
